"use strict";

import angular from "angular";

/**
 * @class nuSelect
 * O <nu-select> é um componente que é usado para selecionar um valor dentro de uma lista
 */

import template from "./select.component.html";
import "./select.component.scss";

const name = "nuSelect";
const def = {
    bindings: {
        action: "=",
        items: "=",
        model: "="
    },
    controllerAs: "selectCtrl",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
